"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";

export default function HeroSection() {
	const t = useTranslations("Hero");
	const tCommon = useTranslations("Common");

	return (
		<section className="relative w-full text-left text-white font-sans">
			<div className="relative w-full h-[65rem] min-[600px]:h-[80rem]">
				<Image
					src="/assets/vendors/laptop-computer-writing-working.webp"
					alt={t("imageAlt")}
					fill
					className="object-cover grayscale-[50%] z-0"
					priority
					fetchPriority="high"
					sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1920px"
					quality={70}
				/>
				<div className="absolute inset-0 z-10 flex flex-col justify-center">
					<div className="top-content w-full text-left px-[2rem] pt-[2rem] pb-[2rem] min-[600px]:px-[5rem] min-[600px]:pt-[5rem] min-[600px]:pb-[5rem] border-t-[0.1rem] border-b-[0.1rem] border-solid border-bdt-goldenrod">
						<h1 className="text-[4rem] min-[600px]:text-[5rem] font-normal text-[gold] drop-shadow-[0.1rem_0.1rem_#ff0000] mb-[2rem] min-[600px]:mb-[6rem] min-[600px]:pt-0">
							{t("heading")}
						</h1>
						<h2 className="text-[1.7rem] mb-[1rem] min-[600px]:mb-[4rem] min-[600px]:pl-0 pl-0">
							{t("subtext")}
						</h2>
						<p className="pb-[2rem] min-[600px]:pb-[5rem]">
							<Link
								href="/contact"
								className="inline-block px-[2rem] min-[600px]:px-[5rem] py-[1.5rem] min-[600px]:py-[2rem] bg-white text-black text-[1.9rem] no-underline hover:bg-bdt-blue hover:text-black transition-colors font-sans"
							>
								{t("ctaButton")}
							</Link>
						</p>
					</div>
				</div>
				<div className="absolute bottom-0 left-0 z-20 py-8 px-8 min-[600px]:py-[3rem] min-[600px]:px-[5rem] flex gap-[1.2rem] [&>a]:text-bdt-gold [&>a:hover]:text-bdt-blue [&>a]:transition-colors">
					<a
						href="https://www.facebook.com/businessdevelopmenttogether"
						target="_blank"
						rel="noopener noreferrer"
						aria-label={tCommon("facebook")}
						className="text-[2.5rem] min-[600px]:text-[3.5rem]"
					>
						<FaFacebook className="size-[1em]" />
					</a>
					<a
						href="https://www.instagram.com/businessdevelopmenttogether/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label={tCommon("instagram")}
						className="text-[2.5rem] min-[600px]:text-[3.5rem]"
					>
						<FaInstagram className="size-[1em]" />
					</a>
					<a
						href="https://twitter.com/Busines79877466"
						target="_blank"
						rel="noopener noreferrer"
						aria-label={tCommon("twitter")}
						className="text-[2.5rem] min-[600px]:text-[3.5rem]"
					>
						<FaTwitter className="size-[1em]" />
					</a>
					<a
						href="https://www.linkedin.com/company/business-development-together/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label={tCommon("linkedin")}
						className="text-[2.5rem] min-[600px]:text-[3.5rem]"
					>
						<FaLinkedin className="size-[1em]" />
					</a>
				</div>
			</div>
		</section>
	);
}
